import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { ProgressSpinner } from "primereact/progressspinner";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import AdminMenu from "../../AdminMenu";
import { getBrandIncomeExpense } from "../../../services/IncomeExpense/IncomeExpense";
import IncomeExpenseCreateModal from "./IncomeExpenseCreateModal";

const IncomeExpense = () => {
  const navigate = useNavigate();
  // const [incomeExpenseData, setIncomeExpenseData] = useState([]);
  const [incomeData, setIncomeData] = useState([]);
  const [expenseData, setExpenseData] = useState([]);
  const [selectedUserItemValue, setSelectedUserItemValue] = useState(null);

  const [visible, setVisible] = useState(false);

  const { brandProfileData } = getUserData();
  let brandId = brandProfileData.id;
  const [loading, setLoading] = useState(false);

  const fetchIncomeExpense = () => {
    setLoading(true);
    getBrandIncomeExpense(brandId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const ResIncome = response.data.filter(
            (item) => item.incomeExpenseCategory.name === "Income"
          );
          const ResExpense = response.data.filter(
            (item) => item.incomeExpenseCategory.name === "Expense"
          );
          setIncomeData(ResIncome);
          setExpenseData(ResExpense);
          //  setIncomeExpenseData(Res)
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchIncomeExpense();
  }, []);

  const [searchTerm, setSearchTerm] = useState("");
  const [incomeExpenseCreateModalVisible, setIncomeExpenseCreateModalVisible] =
    useState(false);

  const receiveDataFromIncomeExpenseCreateModal = ({ success }) => {
    if (success) {
      fetchIncomeExpense();
      setSelectedUserItemValue(null);
    }
  };

  const filterIncomeData = (data, searchTerm) => {
    if (!searchTerm) return data; // Return full data if search is empty

    const searchLower = searchTerm.toLowerCase();

    return data.filter((item) =>
      Object.values(item).some((value) =>
        typeof value === "string" || typeof value === "number"
          ? value.toString().toLowerCase().includes(searchLower)
          : false
      )
    );
  };

  const filteredIncomeData = filterIncomeData(incomeData, searchTerm);

  const filterExpenseData = (data, searchTerm) => {
    if (!searchTerm) return data; // Return full data if search is empty

    const searchLower = searchTerm.toLowerCase();

    return data.filter((item) =>
      Object.values(item).some((value) =>
        typeof value === "string" || typeof value === "number"
          ? value.toString().toLowerCase().includes(searchLower)
          : false
      )
    );
  };

  const filteredExpenseData = filterExpenseData(expenseData, searchTerm);

  const handleClearSearch = () => {
    setSearchTerm("");
  };

  const renderIncomeCardItem = (data) => {
    return data?.map((item, index) => {
      return (
        <div>
          <div
            className="mx-4 my-2 shadow-4 px-3 py-1"
            style={{
              backgroundColor: "#F8FFEE",
              borderTopRightRadius: 20,
              borderBottomLeftRadius: 20,
            }}
          >
            <div className="flex justify-content-end gap-2">
              <p
                className="text-lg font-semibold"
                style={{ color: item.status === true ? "green" : "red" }}
              >
                {item.status === true ? "ACTIVE" : "DeACTIVE"}
              </p>
              <div
                onClick={() => {
                  setIncomeExpenseCreateModalVisible(true);
                  setSelectedUserItemValue(item);
                }}
              >
                <i
                  className="pi pi-pencil"
                  style={{
                    fontSize: "20px",
                    cursor: "pointer",
                    color: "#2B70D7",
                  }}
                ></i>
              </div>
            </div>
            <div
              className="mx-2 shadow-4 px-3"
              style={{
                backgroundColor: "green",
                borderTopRightRadius: 15,
                borderBottomLeftRadius: 15,
              }}
            >
              <p
                className="text-3xl font-semibold"
                style={{ color: "#fff" }}
              >
                {item.name}
              </p>
            </div>
            <p className="text-lg font-medium mt-2"> {item.description}</p>
          </div>
        </div>
      );
    });
  };
  const renderExpenseCardItem = (data) => {
    return data?.map((item, index) => {
      return (
        <div>
          <div
            className="mx-4 my-2 shadow-4 px-3 py-1"
            style={{
              backgroundColor: "#F8FFEE",
              borderTopRightRadius: 20,
              borderBottomLeftRadius: 20,
            }}
          >
            <div className="flex justify-content-end gap-2">
              <p
                className="text-lg font-semibold"
                style={{ color: item.status === true ? "green" : "red" }}
              >
                {item.status === true ? "ACTIVE" : "DeACTIVE"}
              </p>
              <div
                onClick={() => {
                  setIncomeExpenseCreateModalVisible(true);
                  setSelectedUserItemValue(item);
                }}
              >
                <i
                  className="pi pi-pencil"
                  style={{
                    fontSize: "20px",
                    cursor: "pointer",
                    color: "#2B70D7",
                  }}
                ></i>
              </div>
            </div>
            <div
              className="mx-2 shadow-2 px-3"
              style={{
                backgroundColor: "red",
                borderTopRightRadius: 15,
                borderBottomLeftRadius: 15,
              }}
            >
              <p
                className="text-3xl font-semibold"
                style={{ color: "#fff" }}
              >
                {item.name}
              </p>
            </div>
            <p className="text-lg font-medium mt-2"> {item.description}</p>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/Setting")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                INCOME/ EXPENSE
              </p>
            </div>
            <div
              onClick={() => setIncomeExpenseCreateModalVisible(true)}
              className="flex justify-content-center align-items-center mx-4 cursor-pointer"
            >
              <div>
                <img src={"images/plus.png"} style={{ width: 27 }} />
              </div>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="my-2 mx-5 flex flex-1">
        <div className="flex-1">
          <IconField iconPosition="left" className="flex flex-1">
            <InputIcon className="pi pi-search text-xl"> </InputIcon>
            <InputText
              placeholder={"Search Income/ Expense"}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="text-xl flex flex-1 py-1 px-5"
              style={{ borderRadius: 30 }}
            />
          </IconField>
        </div>

        {searchTerm && (
          <div
            className="flex justify-content-center align-items-center mx-2 cursor-pointer"
            onClick={handleClearSearch}
          >
            <div>
              <p className="text-4xl font-bold " style={{ color: "red" }}>
                X
              </p>
            </div>
          </div>
        )}
      </div>
      <div>
        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : (
          <div className="flex flex-1 justify-content-between">
            <div className="flex-1">
              <div>
                <div
                  className="flex-1  surface-0"
                  style={{ "--surface-0": "#EAEFF5" }}
                >
                  <div className="flex justify-content-between mx-4">
                    <div className="py-1">
                      <p className=" text-2xl  font-bold ">INCOME</p>
                    </div>
                  </div>
                </div>
                {incomeData?.length > 0 ? (
                  <div>{renderIncomeCardItem(filteredIncomeData || incomeData)}</div>
                ) : (
                  <div className="flex justify-content-center">
                    <p className="text-xl font-medium">No Income Found</p>
                  </div>
                )}
              </div>
            </div>
            <div className="flex-1">
              <div>
                <div
                  className="flex-1  surface-0"
                  style={{ "--surface-0": "#EAEFF5" }}
                >
                  <div className="flex justify-content-between mx-4">
                    <div className="py-1">
                      <p className=" text-2xl  font-bold ">EXPENSE</p>
                    </div>
                  </div>
                </div>
                {expenseData?.length > 0 ? (
                  <div>
                    {renderExpenseCardItem(filteredExpenseData || expenseData)}
                  </div>
                ) : (
                  <div className="flex justify-content-center">
                    <p className="text-xl font-medium">No Expense Found</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      <AdminMenu setVisible={setVisible} visible={visible} />

      <IncomeExpenseCreateModal
        setIncomeExpenseCreateModalVisible={setIncomeExpenseCreateModalVisible}
        incomeExpenseCreateModalVisible={incomeExpenseCreateModalVisible}
        sendDataToUserList={receiveDataFromIncomeExpenseCreateModal}
        brandId={brandId}
        selectedUserItemValue={selectedUserItemValue}
      />
    </div>
  );
};

export default IncomeExpense;
